import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBtWQZO-pjFUPL5YOmGiHS4B8YTreZbPBw",
  authDomain: "dulynoted-8677b.firebaseapp.com",
  projectId: "dulynoted-8677b",
  storageBucket: "dulynoted-8677b.appspot.com",
  messagingSenderId: "852322686283",
  appId: "1:852322686283:web:88d7b5032d0ab3df0984ce"
};

export const app = initializeApp(firebaseConfig);
export const database=getFirestore(app)
export const storage=getStorage(app);
